import { Moment } from 'moment';

export interface TrainingLoadParams {
    startDate: Moment;
    endDate: Moment;
    startWeek: number;
    startYear: number;
    endWeek: number;
    endYear: number;
}

export enum TrainingLoadType {
    Individual = 'individual',
    Plan = 'plan',
    Group = 'group'
}
